import type { ReactNode } from 'react';
import { Spinner } from './Spinner';

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-3 py-16 text-sm text-ink-muted"
    >
      <Spinner className="h-5 w-5" />
      {label}
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div role="alert" className="card flex flex-col items-center gap-3 px-6 py-10 text-center">
      <div className="text-sm font-medium text-danger-300">{message}</div>
      {onRetry && (
        <button type="button" className="btn-secondary" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
  icon,
  compact = false,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
  /** Flush variant for inside an existing panel/card. */
  compact?: boolean;
}) {
  return (
    <div
      className={
        compact
          ? 'flex flex-col items-center gap-2 px-4 py-6 text-center'
          : 'card flex flex-col items-center gap-3 px-6 py-14 text-center'
      }
    >
      {icon && <div className="text-ink-faint">{icon}</div>}
      <div className={`font-medium text-ink ${compact ? 'text-sm' : 'text-base'}`}>
        {title}
      </div>
      {description && (
        <div className={`max-w-md text-ink-muted ${compact ? 'text-xs' : 'text-sm'}`}>
          {description}
        </div>
      )}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
